/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {HttpTestingController, RequestMatch} from './src/api';
export {HttpClientTestingModule} from './src/module';
export {TestRequest} from './src/request';
